'use client'

import { Outlet } from 'react-router-dom'
import { MeseroProvider } from '@/modules/mesero/MeseroProvider'

export default function MeseroRoot() {
  return (
    <MeseroProvider>
      <Outlet />
    </MeseroProvider>
  )
}

